import { initElmApp } from 'elm/utilities'
import * as Roles from 'elm/src/Roles.elm'

export function init (): null {
  initElmApp(Roles)
}
